import { useCallback, useContext } from "react";

import { Context, ActionType } from "../context/Auth";

const useLogout = () => {
    const { dispatch } = useContext(Context);

    return useCallback(() => {
        dispatch({ type: ActionType.LOGOUT });
    }, [dispatch]);
};

export default useLogout;
